export enum EnumAffinities {
    User = 'User',
    Group = 'Group',
    Member = 'Member',
    Organization = 'Organization',
    Application = 'Application',
    Any = 'Any',
}
